/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const ContactUs = ({ width, height }) => {
  return (
    <svg
      className="animated"
      id="freepik_stories-active-support"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 750 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-active-support:not(.animated) .animable {opacity: 0;}svg#freepik_stories-active-support.animated #freepik--background-complete--inject-21 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-active-support.animated #freepik--Plants--inject-21 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-active-support.animated #freepik--speech-bubble--inject-21 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-active-support.animated #freepik--Device--inject-21 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-active-support.animated #freepik--Character--inject-21 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}            @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ',
        }}
      />
      <g
        id="freepik--background-complete--inject-21"
        style={{ transformOrigin: '374.6304626464844px 264.80499267578125px' }}
        className="animable"
      >
        <path
          d="M183.73,396.78c10.85-7.57,14.5-16.9,15.74-30.07a46.39,46.39,0,0,0-12.85-36.25c-7.71-7.88-18.32-13.06-24.07-22.48-6.12-10-5.91-23.71-14.41-31.83-5.84-5.57-14.38-7.06-21.48-10.92-5.79-3.15-10.55-7.85-15.85-11.77s-11.59-7.17-18.16-6.68c-9.91.75-17.63,10.48-18.1,20.41s5.07,19.43,12.65,25.86c5.5,4.67,12.27,8.24,15.87,14.49,6.76,11.73-.3,28,7,39.46,5.3,8.35,17.33,12.34,19,22.09.61,3.59-.41,7.24-.38,10.88.09,11.37,10.72,20.54,21.92,22.55s22.61-1.49,33.16-5.74"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '137.08343505859375px 324.9168930053711px',
          }}
          id="els995u7sscz"
          className="animable"
        />
        <path
          d="M114.13,286.75a8.23,8.23,0,0,0,1.19,1.33l3.6,3.62c1.59,1.54,3.51,3.45,5.59,5.81s4.63,4.87,7.09,8c1.27,1.52,2.6,3.11,4,4.77s2.67,3.5,4.08,5.34c2.88,3.65,5.59,7.82,8.53,12.14a240.51,240.51,0,0,1,16.27,29.8,240.55,240.55,0,0,1,11.48,32c1.28,5.07,2.6,9.86,3.42,14.44.44,2.28,1,4.46,1.29,6.6s.63,4.17.92,6.13c.68,3.9.91,7.47,1.26,10.6s.53,5.82.63,8,.23,3.79.31,5.09a8.41,8.41,0,0,0,.21,1.78,9.45,9.45,0,0,0,.07-1.78c0-1.31,0-3-.06-5.11s-.1-4.94-.4-8.08-.44-6.73-1.06-10.66q-.41-3-.85-6.18c-.3-2.14-.8-4.35-1.22-6.64-.77-4.62-2-9.44-3.31-14.55A230.1,230.1,0,0,0,165.69,357,233.51,233.51,0,0,0,149.23,327c-3-4.32-5.74-8.49-8.68-12.13-1.44-1.84-2.76-3.67-4.16-5.32l-4.06-4.74c-2.52-3.07-5.1-5.58-7.27-7.87s-4.12-4.17-5.77-5.66l-3.78-3.44A10,10,0,0,0,114.13,286.75Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '149.10715866088867px 364.47499084472656px',
          }}
          id="el3eudjfjba3i"
          className="animable"
        />
        <path
          d="M670.06,202.22s-9.54-6.31-21.17,16.51-16,36-16,36-3.08,4.78-6.36,1.65-7.78-12-13.36-10.39c-5.79,1.65-7.7,8.11-6.6,17.61s2.76,30.38,2.91,32.27-.93,4.59-3.5,2.82-17.41-18.29-24.83-10.78,0,33.45.76,36.3.2,4.07-1.16,4.78-5.81-5.32-10.22-9.85-10.32-9-14.24-4.31-5.17,24.16,13.36,55.78l9.54,14.09,17.07-.95c36.4-4.25,51.18-17,52.57-22.92s-5.75-8-12-8.77-13.76-.74-14-2.24.38-2.69,3.11-3.8,27.92-10.81,29.44-21.25-20.59-12.34-23.55-13.33-1.43-3.49.14-4.49,19.26-12.29,27.51-17.12,12.25-10.25,10.09-15.87c-2.09-5.42-11.88-3.67-16.35-4.41s-2.51-6.07-2.51-6.07S658.51,252,669.72,229s.14-26.89.14-26.89"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '614.3137245178223px 293.05992889404297px',
          }}
          id="ellvjnxhel25"
          className="animable"
        />
        <path
          d="M659.61,222.64s-.06.17-.21.49-.38.81-.66,1.43c-.61,1.27-1.49,3.1-2.61,5.46-2.28,4.75-5.61,11.59-9.76,20-8.31,16.88-20,40.1-32.93,65.7s-24.69,48.8-33.07,65.64l-9.91,19.94c-1.17,2.34-2.07,4.17-2.7,5.43-.31.6-.54,1.06-.71,1.4l-.26.47s.06-.17.21-.49l.66-1.43c.61-1.27,1.49-3.11,2.61-5.47,2.27-4.74,5.61-11.58,9.76-20,8.31-16.88,20-40.1,32.94-65.71s24.67-48.79,33.06-65.62l9.91-19.95,2.7-5.42c.31-.6.54-1.07.71-1.4S659.61,222.64,659.61,222.64Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '613.1999816894531px 315.61998748779297px',
          }}
          id="elmvampddlhm"
          className="animable"
        />
        <path
          d="M618.93,258.62a5.56,5.56,0,0,1,.43,1.16c.25.75.57,1.85,1,3.21.77,2.72,1.74,6.5,2.73,10.7s1.84,7.88,2.5,10.75l.78,3.25a5,5,0,0,1,.24,1.21,5.56,5.56,0,0,1-.43-1.16c-.25-.75-.57-1.85-.95-3.21-.74-2.73-1.66-6.53-2.65-10.72s-1.9-7.87-2.58-10.73c-.32-1.29-.59-2.37-.8-3.25A5.27,5.27,0,0,1,618.93,258.62Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '622.7699890136719px 273.75999450683594px',
          }}
          id="ellfnzgnbe1ka"
          className="animable"
        />
        <path
          d="M628.14,289.2c0-.14,7.67-2.48,17.23-5.23s17.33-4.86,17.37-4.72-7.67,2.48-17.23,5.23S628.18,289.34,628.14,289.2Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '645.4400806427002px 284.22499561309814px',
          }}
          id="elxnohwf47ur"
          className="animable"
        />
        <path
          d="M606.45,327.62a7,7,0,0,1,1.26-.06l3.41,0c2.89,0,6.87,0,11.26-.18s8.36-.44,11.24-.67l3.4-.27a6.35,6.35,0,0,1,1.26,0,5.91,5.91,0,0,1-1.23.25c-.8.12-2,.27-3.4.43-2.87.33-6.84.67-11.25.83s-8.4.12-11.28,0c-1.45-.06-2.61-.12-3.42-.18A5.45,5.45,0,0,1,606.45,327.62Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '622.3650207519531px 327.23209553956985px',
          }}
          id="el8wkng9cdv2"
          className="animable"
        />
        <path
          d="M592,301.8a4.59,4.59,0,0,1,.66.95l1.65,2.7c1.37,2.28,3.23,5.46,5.26,9s3.84,6.74,5.13,9.07l1.5,2.78a4.52,4.52,0,0,1,.48,1.05,5.12,5.12,0,0,1-.66-.95l-1.65-2.69c-1.37-2.29-3.23-5.47-5.26-9s-3.84-6.73-5.12-9.07c-.59-1.09-1.1-2-1.5-2.78A4.7,4.7,0,0,1,592,301.8Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '599.3399963378906px 314.5749816894531px',
          }}
          id="el1pv3wkn9rq6"
          className="animable"
        />
        <path
          d="M568.59,333.29a7.94,7.94,0,0,1,.84,1.23l2.12,3.44c1.77,2.92,4.19,7,6.83,11.47s5,8.58,6.7,11.54c.8,1.43,1.46,2.62,2,3.53a7.45,7.45,0,0,1,.66,1.34,8.66,8.66,0,0,1-.84-1.23l-2.12-3.45c-1.77-2.92-4.19-7-6.83-11.46s-5-8.58-6.7-11.55l-2-3.53A7.61,7.61,0,0,1,568.59,333.29Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '578.1650085449219px 349.5649871826172px',
          }}
          id="elc0ommt7w7zp"
          className="animable"
        />
        <path
          d="M587.48,364.93a8.15,8.15,0,0,1,1.59-.11l4.33-.15c3.66-.12,8.71-.31,14.27-.67s10.6-.82,14.24-1.18l4.32-.42a9,9,0,0,1,1.59-.09,9.21,9.21,0,0,1-1.57.3c-1,.16-2.48.36-4.29.59-3.64.45-8.67,1-14.25,1.32s-10.64.5-14.3.53c-1.83,0-3.31,0-4.34,0A8.42,8.42,0,0,1,587.48,364.93Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '607.6500549316406px 363.6784715652466px',
          }}
          id="el5o9snvfclhu"
          className="animable"
        />
        <path
          d="M464.47,87.41h68.65a5.41,5.41,0,0,1,5.41,5.41v45.49a5.41,5.41,0,0,1-5.41,5.41H497l-17.19,17.19V143.72H464.47a4,4,0,0,1-4-4V91.42A4,4,0,0,1,464.47,87.41Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '499.49999237060547px 124.1600112915039px',
          }}
          id="elnm99cgd5w3"
          className="animable"
        />
        <path
          d="M487.25,116.52a4,4,0,1,1-4-4A4,4,0,0,1,487.25,116.52Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '483.25px 116.5199966430664px',
          }}
          id="el6i67rc31jz6"
          className="animable"
        />
        <path
          d="M503.23,116.52a4,4,0,1,1-4-4A4,4,0,0,1,503.23,116.52Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '499.2300109863281px 116.5199966430664px',
          }}
          id="elcsjtwwxhbv"
          className="animable"
        />
        <path
          d="M519.2,116.52a4,4,0,1,1-4-4A4,4,0,0,1,519.2,116.52Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '515.2000122070312px 116.5199966430664px',
          }}
          id="eluryxizofdya"
          className="animable"
        />
      </g>
      <g
        id="freepik--Plants--inject-21"
        style={{ transformOrigin: '394.2650146484375px 377.9735107421875px' }}
        className="animable"
      >
        <path
          d="M576,430.88c-17.18-16.71-17.48-42.56-13-65,.74-3.75,1-7.79,3.31-10.81s6.89-4.6,10-2.46c2.59,1.78,3.28,5.24,4.41,8.19a22.39,22.39,0,0,0,7.47,9.89c2.2,1.63,5,2.88,7.63,2,3.54-1.27,4.66-5.7,5.25-9.45q1.63-10.5,3.28-21c.59-3.75,1.21-7.59,2.95-11s4.87-6.25,8.6-6.67,7.81,2.36,8,6.15c.07,1.58-.5,3.12-.65,4.69s.29,3.42,1.7,4.09,3.1-.13,4.4-1.05c4.49-3.16,7.91-7.61,11.16-12.06s6.44-9,10.62-12.59,9.58-6,15-5.47,10.61,4.82,11.11,10.32-3.46,10.37-7.52,14.1a84.65,84.65,0,0,1-20.14,13.78c-1.32.65-2.75,1.35-3.43,2.66-1.22,2.37.75,5.24,3.08,6.46,2.65,1.39,5.73,1.59,8.6,2.42s5.82,2.62,6.48,5.57c.91,4.08-2.95,7.58-6.54,9.7a72.55,72.55,0,0,1-23.22,8.79c-2.92.56-6,1-8.51,2.55s-4.44,4.73-3.52,7.59,4.22,4.27,7.2,4.21,5.82-1.22,8.74-1.81c5.48-1.1,12.08.34,14.65,5.33,1.7,3.28,1.22,7.39-.45,10.71s-4.38,5.95-7.19,8.34c-9.84,8.35-21.69,14.43-34.33,16.62s-23.9,1.52-35.07-4.76"
          style={{
            fill: '#95BD51',
            transformOrigin: '618.9220314025879px 372.5309753417969px',
          }}
          id="elys55atkxr8"
          className="animable"
        />
        <path
          d="M573,447.58a166.67,166.67,0,0,1,11.17-29.92,339.14,339.14,0,0,1,19.24-34l5.5-8.66c1.81-2.84,3.61-5.65,5.54-8.29a169.23,169.23,0,0,1,11.94-14.56c4-4.45,8-8.52,11.76-12.3s7.33-7.22,10.72-10.23a135.37,135.37,0,0,1,17-13c2.13-1.37,3.81-2.38,5-3l1.31-.76a3,3,0,0,1,.46-.23,4.19,4.19,0,0,1-.42.3l-1.28.81c-1.12.7-2.78,1.75-4.88,3.15A143.22,143.22,0,0,0,649.2,330c-3.36,3-6.9,6.49-10.63,10.28s-7.69,7.87-11.69,12.32A170.84,170.84,0,0,0,615,367.1c-1.91,2.63-3.69,5.43-5.51,8.27S605.86,381.1,604,384a350.28,350.28,0,0,0-19.25,33.92,169.8,169.8,0,0,0-11.27,29.77"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '622.8199768066406px 380.1599884033203px',
          }}
          id="elz3gkpmq34kb"
          className="animable"
        />
        <path
          d="M614.66,366.7a7.85,7.85,0,0,1-.11-1.66c0-1.07,0-2.61,0-4.53.07-3.82.36-9.09.7-14.9s.56-11.08.58-14.89c0-1.91,0-3.45,0-4.52a7.19,7.19,0,0,1,.06-1.66,7.46,7.46,0,0,1,.21,1.65c.1,1.06.18,2.61.23,4.52.11,3.82,0,9.11-.37,14.93s-.67,10.93-.91,14.89c-.1,1.79-.18,3.3-.24,4.52A8,8,0,0,1,614.66,366.7Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '615.4571729898453px 345.62001037597656px',
          }}
          id="el4k19gt5azij"
          className="animable"
        />
        <path
          d="M664.36,365.55a10.7,10.7,0,0,1-2-.09c-1.26-.09-3.08-.23-5.32-.33-4.5-.25-10.72-.36-17.59-.19s-13.08.61-17.57,1.05c-2.24.2-4,.42-5.3.56a10.55,10.55,0,0,1-2,.15,10.21,10.21,0,0,1,1.92-.43c1.24-.22,3-.51,5.29-.78,4.49-.57,10.71-1.08,17.61-1.26a172.82,172.82,0,0,1,17.63.4c2.25.17,4.07.38,5.32.56A9.8,9.8,0,0,1,664.36,365.55Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '639.469970703125px 365.4313477277756px',
          }}
          id="elasi97fdhg5p"
          className="animable"
        />
        <path
          d="M584.92,416.87s-.11-.21-.24-.64-.32-1.13-.54-1.88c-.46-1.63-1.07-4-1.78-7-1.43-5.9-3.14-14.12-4.91-23.21s-3.4-17.32-4.7-23.25c-.64-2.88-1.17-5.25-1.57-7-.16-.77-.3-1.4-.41-1.91a2.68,2.68,0,0,1-.1-.68s.11.21.24.64.32,1.13.54,1.88c.46,1.63,1.07,4,1.78,7,1.42,5.9,3.14,14.12,4.91,23.22s3.4,17.31,4.7,23.24l1.56,7c.17.76.31,1.4.42,1.91A2.63,2.63,0,0,1,584.92,416.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '577.7950439453125px 384.0850067138672px',
          }}
          id="el2w12v63j2q5"
          className="animable"
        />
        <path
          d="M652.37,406.66a2.8,2.8,0,0,1-.68.16l-2,.32-7.23,1.1c-6.1.94-14.51,2.33-23.8,3.87S601,415,594.85,415.78c-3.06.41-5.54.71-7.26.88l-2,.19a2.13,2.13,0,0,1-.69,0,2.63,2.63,0,0,1,.68-.16l2-.32,7.22-1.1c6.1-.94,14.52-2.33,23.81-3.87s17.72-2.86,23.85-3.67c3.06-.41,5.54-.71,7.26-.88l2-.19A2.58,2.58,0,0,1,652.37,406.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '618.635009765625px 411.75878524780273px',
          }}
          id="el5mz2u03k7j"
          className="animable"
        />
        <path
          d="M114.62,352c5.41-1.45,11.33-.08,16.09,2.86A36.8,36.8,0,0,1,142.15,367c5.75,9.19,7.72,21.5,7.91,32.34-12-.56-22.24-10.07-27.12-15.22-7.71-8.14-16.72-27.53-8.32-32.08"
          style={{
            fill: '#95BD51',
            transformOrigin: '130.65362548828125px 375.37874603271484px',
          }}
          id="elr9x2th0xh5"
          className="animable"
        />
        <path
          d="M169.37,406.64c-4.92-3.86-7.09-10.66-6-16.82a23.62,23.62,0,0,1,10.27-15.11c2.39-1.63,5.36-2.91,8.13-2.07a7.6,7.6,0,0,1,4.89,6,15.43,15.43,0,0,1-1,8c-3.09,8.75-7.68,16.65-16.29,20.08"
          style={{
            fill: '#95BD51',
            transformOrigin: '174.95256519317627px 389.5472869873047px',
          }}
          id="elwe7s8q33aw"
          className="animable"
        />
        <path
          d="M180.29,440.93a8.19,8.19,0,0,1-1.2-1.94c-.69-1.28-1.67-3.16-2.8-5.51a76.62,76.62,0,0,1-6.66-19.35c-1.42-8-.38-15.46,1.62-20.35a24.35,24.35,0,0,1,2.94-5.5,7.13,7.13,0,0,1,1.49-1.73c.21.13-1.93,2.65-3.63,7.53a40.08,40.08,0,0,0-1.22,19.84,88.43,88.43,0,0,0,6.24,19.2C179.14,437.9,180.45,440.85,180.29,440.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '174.6382565498352px 413.73997497558594px',
          }}
          id="el01e8i44i989l"
          className="animable"
        />
        <path
          d="M122.78,366.16a21.14,21.14,0,0,1,2.61,2.7c1.62,1.79,3.92,4.42,6.73,7.7,5.61,6.55,13.22,15.74,21.38,26.09s15.29,19.9,20.35,26.9c2.53,3.5,4.55,6.35,5.91,8.35a21.76,21.76,0,0,1,2,3.16,23.26,23.26,0,0,1-2.39-2.89l-6.22-8.11c-5.23-6.86-12.48-16.32-20.62-26.66s-15.64-19.6-21.08-26.29L125,369.16A22.85,22.85,0,0,1,122.78,366.16Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '152.27000427246094px 403.6100158691406px',
          }}
          id="elz2ltkf2dzeb"
          className="animable"
        />
        <path
          d="M161.25,420a41.64,41.64,0,0,0-37.35-7.24c-3.21,1-6.78,2.93-7.1,6.27s2.81,6,5.83,7.47a35.58,35.58,0,0,0,39.06-5.7"
          style={{
            fill: '#95BD51',
            transformOrigin: '139.23368072509766px 420.5202808380127px',
          }}
          id="ell5g3j07qq9i"
          className="animable"
        />
        <path
          d="M131.89,418.88a7.58,7.58,0,0,1,2.09-.63,18.65,18.65,0,0,1,2.52-.46,30,30,0,0,1,3.37-.35,43.7,43.7,0,0,1,8.83.39,46.72,46.72,0,0,1,20,7.92,44,44,0,0,1,6.7,5.76,27.8,27.8,0,0,1,2.23,2.56,17.76,17.76,0,0,1,1.52,2.06,7.6,7.6,0,0,1,1.09,1.88c-.19.14-1.91-2.45-5.45-5.9a49,49,0,0,0-6.72-5.44,54.89,54.89,0,0,0-9.37-4.92,53.72,53.72,0,0,0-10.19-2.81,48.53,48.53,0,0,0-8.63-.64C135,418.4,131.94,419.11,131.89,418.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '156.06500244140625px 427.6920471191406px',
          }}
          id="elkw26jbx8788"
          className="animable"
        />
      </g>
      <g
        id="freepik--speech-bubble--inject-21"
        style={{ transformOrigin: '276.5337448120117px 111.84682083129883px' }}
        className="animable"
      >
        <path
          d="M296.39,94.17l-8.39,7-4.08-1.82-.84-3.46s9-6.65,8.67-7a5.18,5.18,0,0,0-3.09-1.42,8.27,8.27,0,0,0-6.08,1.63L281,90.29a9.71,9.71,0,0,0-3.83,9.43,3,3,0,0,0,.06.31L252.36,120.7a8,8,0,1,0,5.29,5.86l24.59-20.64a5.21,5.21,0,0,0,3.53,1.28,9.16,9.16,0,0,0,6.67-2.7l2.08-2A8.35,8.35,0,0,0,296.39,94.17Zm-48,37.47a3.67,3.67,0,1,1,4.84-1.85A3.67,3.67,0,0,1,248.35,131.64Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '269.3214340209961px 111.84741401672363px',
          }}
          id="elhzbowkaub5e"
          className="animable"
        />
        <path
          d="M334,141.87l-26.78,2.24.09-.05a49.77,49.77,0,0,1-37.24,17.85,51.68,51.68,0,0,1-17.36-2.75,49.37,49.37,0,0,1-16.44-9.49A50,50,0,0,1,219.06,113a17.91,17.91,0,0,1,0-2.74c0-.91.1-1.83.14-2.75a21.16,21.16,0,0,1,.35-2.74L220,102c.19-.91.45-1.81.67-2.71s.43-1.83.74-2.71.64-1.76,1-2.64l.48-1.33c.16-.44.4-.86.59-1.29a50.79,50.79,0,0,1,12.75-17.15A49.47,49.47,0,0,1,273.65,62a50.09,50.09,0,0,1,40.58,28.32,25.35,25.35,0,0,1,1.48,3.4c.41,1.15.84,2.27,1.22,3.4a53.7,53.7,0,0,1,1.51,6.72c.15,1.1.36,2.17.45,3.24s.1,2.13.15,3.16c0,.52,0,1,.08,1.54s-.05,1-.07,1.51c0,1-.09,2-.14,2.92l0-.09c9.49,16.12,14.6,24.79,15.15,25.74l-15.4-25.58,0,0v0q.06-1.42.12-2.91c0-.5.05-1,.06-1.5s-.05-1-.08-1.53c-.05-1-.11-2.07-.16-3.14s-.32-2.12-.47-3.22a52.85,52.85,0,0,0-1.51-6.66c-.38-1.12-.81-2.23-1.23-3.37a26.26,26.26,0,0,0-1.47-3.37,49.47,49.47,0,0,0-77.35-16,50.42,50.42,0,0,0-12.6,17c-.2.43-.43.83-.59,1.27l-.48,1.32-1,2.61c-.31.88-.48,1.79-.73,2.68s-.48,1.78-.67,2.68-.27,1.82-.41,2.72a22.71,22.71,0,0,0-.34,2.72c-.05.91-.1,1.81-.14,2.72a18.87,18.87,0,0,0,0,2.71,49.64,49.64,0,0,0,33.32,45.77,51.49,51.49,0,0,0,17.2,2.75,49.52,49.52,0,0,0,37-17.6l0,0h.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '276.5337448120117px 111.8468246459961px',
          }}
          id="el46lrz5nn88w"
          className="animable"
        />
      </g>
      <g
        id="freepik--Device--inject-21"
        style={{ transformOrigin: '378.2949981689453px 319.22999572753906px' }}
        className="animable"
      >
        <rect
          x="173.75"
          y="182.49"
          width="408.03"
          height="269.83"
          rx="14.57"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '377.765px 317.405px',
          }}
          id="el8lj2ns47h55"
          className="animable"
        />
        <path
          d="M157.26,432.36H599.33a0,0,0,0,1,0,0v5.81a17.8,17.8,0,0,1-17.8,17.8H175.06a17.8,17.8,0,0,1-17.8-17.8v-5.81A0,0,0,0,1,157.26,432.36Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '378.2949981689453px 444.16497802734375px',
          }}
          id="elpqs6fkixk3e"
          className="animable"
        />
        <rect
          x="185.28"
          y="193.21"
          width="384.98"
          height="227.86"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '377.77px 307.14px',
          }}
          id="eljgwipgc8wsa"
          className="animable"
        />
        <path
          d="M338.11,432.36h1.72l5,0,18.65-.08,62.37-.13h.46l-.23.4c-.78,1.34-1.63,2.78-2.47,4.24s-1.78,3-2.62,4.48l-.08.13h-.15l-77.19-.14h-.07l0-.06-4-6.57-1-1.67-.33-.55.39.58c.25.4.61.95,1.08,1.67.94,1.47,2.33,3.62,4.12,6.42l-.1-.06,77.19-.14-.23.13,2.62-4.49c.85-1.45,1.69-2.9,2.48-4.24l.22.4-62.11-.14L345,432.42l-5.11,0h-1.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '382.20997619628906px 436.7749938964844px',
          }}
          id="el6vr5l7g2k2c"
          className="animable"
        />
        <path
          d="M326.15,235.6a13.14,13.14,0,0,1,2.45-2.49l-.58-3.19,4.93-2.11,1.9,2.63a13.14,13.14,0,0,1,3.49,0l1.84-2.66,5,2-.51,3.2a13.44,13.44,0,0,1,2.49,2.45l3.19-.58,2.11,4.93-2.63,1.9a13.14,13.14,0,0,1,0,3.49l2.66,1.85-2,5-3.19-.51a13.5,13.5,0,0,1-2.45,2.5l.58,3.18-4.93,2.11-1.9-2.63a13.22,13.22,0,0,1-3.5,0l-1.84,2.67-5-2,.51-3.2a13.2,13.2,0,0,1-2.5-2.45l-3.18.58L321,247.3l2.63-1.9a12.74,12.74,0,0,1,0-3.49L321,240.06l2-5,3.2.51Zm5.34,5.54A5.75,5.75,0,1,0,339,238,5.75,5.75,0,0,0,331.49,241.14Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            fillRule: 'evenodd',
            transformOrigin: '336.74497985839844px 243.55999755859375px',
          }}
          id="el1539y007amn"
          className="animable"
        />
        <path
          d="M306.16,339a38.62,38.62,0,0,1,7.09-7.24l-1.69-9.24,14.29-6.09,5.51,7.61a38.13,38.13,0,0,1,10.13-.12l5.33-7.72,14.42,5.8-1.49,9.26a38.32,38.32,0,0,1,7.24,7.09l9.24-1.68L382.32,351l-7.61,5.5a37.72,37.72,0,0,1,.11,10.13l7.73,5.34-5.8,14.41-9.26-1.49a38.32,38.32,0,0,1-7.09,7.24l1.68,9.24-14.29,6.1-5.5-7.61a38.14,38.14,0,0,1-10.13.11l-5.33,7.72-14.42-5.79,1.49-9.27a38,38,0,0,1-7.24-7.09l-9.24,1.69-6.1-14.29,7.61-5.51a38.06,38.06,0,0,1-.11-10.12L291.1,352l5.79-14.42,9.27,1.49Zm15.46,16.06a16.67,16.67,0,1,0,21.68-9.25A16.67,16.67,0,0,0,321.62,355.08Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            fillRule: 'evenodd',
            transformOrigin: '336.82501220703125px 361.94500732421875px',
          }}
          id="elfld0s1zrf1g"
          className="animable"
        />
        <path
          d="M234,358.27a21.29,21.29,0,0,1,3.92-4l-.93-5.11,7.9-3.37,3,4.21a20.57,20.57,0,0,1,5.6-.06l2.95-4.28,8,3.21L263.6,354a20.94,20.94,0,0,1,4,3.92l5.11-.93,3.38,7.9-4.21,3.05a21.4,21.4,0,0,1,.06,5.6l4.27,3-3.21,8-5.12-.82a21,21,0,0,1-3.93,4l.94,5.11L257,396.12l-3-4.21a20.65,20.65,0,0,1-5.61.06l-3,4.28-8-3.21.83-5.12a21.34,21.34,0,0,1-4-3.93l-5.11.94L225.74,377l4.21-3a21.06,21.06,0,0,1-.06-5.61l-4.27-2.95,3.2-8,5.13.83Zm8.55,8.88a9.22,9.22,0,1,0,12-5.12A9.21,9.21,0,0,0,242.5,367.15Z"
          style={{
            fill: 'none',
            transformOrigin: '250.91500091552734px 370.9550018310547px',
          }}
          id="elil89scu422d"
          className="animable"
        />
        <path
          d="M242.5,367.15a6.87,6.87,0,0,1,1-2,9.12,9.12,0,0,1,5-3.58,9.31,9.31,0,0,1,8.8,2,8.87,8.87,0,0,1,1.76,2.08,9.05,9.05,0,0,1,1.11,2.61,9.4,9.4,0,0,1-4.18,10.4,9.35,9.35,0,0,1-5.31,1.41,9.37,9.37,0,0,1-4.76-1.5,9.33,9.33,0,0,1-4.15-9.21,7.05,7.05,0,0,1,.67-2.18,21.68,21.68,0,0,0-.47,2.21,9.24,9.24,0,0,0,1.28,5.85,9,9,0,0,0,7.44,4.34,8.93,8.93,0,0,0,5-1.36,8.92,8.92,0,0,0,4-9.83A9,9,0,0,0,257,363.9a9.16,9.16,0,0,0-4.23-2.14,9,9,0,0,0-4.15.13,9.2,9.2,0,0,0-5,3.34C242.83,366.4,242.56,367.18,242.5,367.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '251.07263278961182px 370.63890075683594px',
          }}
          id="el7kdt4u6r2fs"
          className="animable"
        />
        <path
          d="M234,358.27l-.32,0-1-.13-3.84-.57.09-.06-3.16,8-.05-.16,4.29,2.93.07.06v.09a21.24,21.24,0,0,0,.08,5.56l0,.1-.09.07-4.2,3.05.06-.22,3.4,7.89-.23-.12,5.11-.94.13,0,.08.11a20.82,20.82,0,0,0,4,3.87l.12.08,0,.14c-.25,1.59-.53,3.34-.81,5.13l-.15-.26,8,3.2-.29.09,2.95-4.28.08-.12.15,0a21.06,21.06,0,0,0,5.54-.07l.15,0,.09.12,3.05,4.21-.31-.08,7.91-3.38-.16.29c-.3-1.62-.61-3.36-.93-5.11l0-.16.12-.1a20.73,20.73,0,0,0,3.87-3.95h0l.1-.13.16,0,5.13.83-.29.16q1.62-4,3.21-8l.09.31-4.27-3-.13-.09,0-.15a21,21,0,0,0-.06-5.54l0-.15.13-.09,4.21-3-.09.3-3.36-7.91.27.15-5.12.92-.14,0-.09-.12a21,21,0,0,0-4-3.88l-.11-.08,0-.14c.29-1.76.56-3.46.83-5.13l.14.24-8-3.22.24-.07-3,4.26-.07.1h-.11a21,21,0,0,0-5.56,0h-.1l-.06-.08c-1.1-1.53-2.1-2.91-3-4.22l.18.05L237,349.26l.07-.13c.36,2,.66,3.72.9,5.12v.05l0,0a22.77,22.77,0,0,0-3.07,2.88l-.67.8-.23.26a2,2,0,0,1,.19-.29c.14-.19.35-.47.64-.83a20.61,20.61,0,0,1,3-2.95l0,.08c-.27-1.39-.58-3.07-1-5.11l0-.09.09,0,7.89-3.41.12,0,.07.1,3.06,4.2-.17-.07a21.22,21.22,0,0,1,5.65-.08l-.17.08c.93-1.36,1.9-2.78,2.94-4.28l.09-.13.15.06,8,3.19.17.06,0,.17c-.27,1.67-.54,3.37-.82,5.13l-.09-.22a21.71,21.71,0,0,1,4.06,4l-.23-.08,5.11-.94.19,0,.08.18q1.63,3.86,3.38,7.9l.08.19-.17.12-4.2,3,.1-.24a21.09,21.09,0,0,1,.06,5.67l-.11-.24,4.28,2.95.17.12-.08.19-3.2,8-.08.19-.21,0-5.13-.82.26-.11h0a21.81,21.81,0,0,1-4,4.05l.09-.26c.32,1.76.64,3.5.94,5.11l0,.21L265,393l-7.91,3.37-.19.08-.12-.16-3-4.22.24.11a21.58,21.58,0,0,1-5.67.05l.24-.1-3,4.27-.11.16-.18-.07-8-3.22-.18-.07,0-.19c.29-1.78.58-3.53.83-5.12l.09.22a21.46,21.46,0,0,1-4-4l.21.08-5.11.92-.16,0-.07-.15q-1.77-4.17-3.35-7.92l-.06-.13.12-.09,4.22-3-.07.17a21.44,21.44,0,0,1-.05-5.65l.07.15-4.26-3-.09-.06,0-.1c1.33-3.24,2.42-5.92,3.25-8l0-.06h.06l3.8.65,1,.18Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '251.02498626708984px 371.0099639892578px',
          }}
          id="elv3xexkysmso"
          className="animable"
        />
        <path
          d="M214.42,252.74A52.07,52.07,0,0,1,221,240.39l-5.87-11.55,16.49-13.68,10.27,7.9a52.23,52.23,0,0,1,13.34-4.13l4-12.31,21.33,2,1.68,12.84A52.6,52.6,0,0,1,294.56,228l11.55-5.86,13.67,16.49-7.89,10.26A52.83,52.83,0,0,1,316,262.21l12.3,4-2,21.33-12.84,1.67A52.21,52.21,0,0,1,307,301.58l5.86,11.55-16.49,13.68-10.27-7.89A52.21,52.21,0,0,1,272.74,323l-4,12.31-21.33-2-1.68-12.83A52.63,52.63,0,0,1,233.36,314l-11.54,5.86-13.68-16.49L216,293.11a52.88,52.88,0,0,1-4.13-13.34l-12.3-4,2-21.33,12.83-1.68Zm26.75,15.14a23,23,0,1,0,25-20.75A23,23,0,0,0,241.17,267.88Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            fillRule: 'evenodd',
            transformOrigin: '263.9349899291992px 270.9649963378906px',
          }}
          id="elh4y7w9fs8o6"
          className="animable"
        />
        <path
          d="M581.78,432.36c0,.14-91.35.25-204,.25s-204-.11-204-.25,91.33-.24,204-.24S581.78,432.23,581.78,432.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '377.780029296875px 432.364990234375px',
          }}
          id="el487tswun61l"
          className="animable"
        />
      </g>
      <g
        id="freepik--Character--inject-21"
        style={{ transformOrigin: '404.0564880371094px 266.0276184082031px' }}
        className="animable"
      >
        <path
          d="M362.32,125.79c-6.29,2.76-9.95,9.55-11.32,16.28s-.93,13.69-1.52,20.54-2.47,14-7.47,18.71c-4.66,4.4-11.51,6.19-15.48,11.22a14.1,14.1,0,0,0,8,22.51c-3.14,5-1.57,11.91,2.45,16.2s9.91,6.34,15.72,7.22c10.22,1.56,21.12-.16,29.75-5.85s14.67-15.57,14.65-25.9"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '360.2948188781738px 182.40375900268555px',
          }}
          id="elznr6fw8tej"
          className="animable"
        />
        <path
          d="M335.07,227.37a8,8,0,0,1-1.11-2.23,13.42,13.42,0,0,1-.4-6.74,19,19,0,0,1,1.44-4.49,25.67,25.67,0,0,1,2.89-4.56,84.52,84.52,0,0,1,8.65-8.75,90.07,90.07,0,0,0,8.41-8.9,41.63,41.63,0,0,0,5.39-8.39,29.32,29.32,0,0,0,2.18-6.35c.19-.77.24-1.39.33-1.8a2.68,2.68,0,0,1,.14-.63,3.08,3.08,0,0,1,0,.64c-.06.42-.08,1.05-.24,1.83a26.91,26.91,0,0,1-2.06,6.46,40.27,40.27,0,0,1-5.34,8.52,86.42,86.42,0,0,1-8.42,9,86,86,0,0,0-8.64,8.68,24.26,24.26,0,0,0-2.87,4.45,18.15,18.15,0,0,0-1.47,4.37,13.59,13.59,0,0,0,.24,6.63A20.59,20.59,0,0,0,335.07,227.37Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '348.1561803817749px 200.94998168945312px',
          }}
          id="eldxiw2tg8z1"
          className="animable"
        />
        <path
          d="M437.54,148.38c0,9.24,4.26,17.71,8.09,20.83,5.43,4.4,13.39,6.53,18.63,8,7.64,2.13,14,8.82,15,16.7s-4.2,16.29-11.88,18.27c4.83,4.93,3.39,13.41-.58,19-7.53,10.69-22.56,14.8-35,10.84s-22-15-25.74-27.53"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '442.7215156555176px 195.94010162353516px',
          }}
          id="elui7acnsqf4"
          className="animable"
        />
        <path
          d="M456.54,239.4a8.07,8.07,0,0,0,2.94-1.29,8.5,8.5,0,0,0,2.46-2.82,10.4,10.4,0,0,0,1.32-4.76,11.72,11.72,0,0,0-1.55-5.76,18.72,18.72,0,0,0-4.49-5.27c-3.79-3.19-8.94-5.18-13.92-8a27.36,27.36,0,0,1-6.6-5.19,15.35,15.35,0,0,1-2.31-3.3,14.77,14.77,0,0,1-1.3-3.63,24.81,24.81,0,0,1-.32-7.08c.17-2.21.45-4.24.64-6.11a27.18,27.18,0,0,0-.14-8.8c-.13-.5-.25-.94-.36-1.34s-.27-.69-.36-.95a7.3,7.3,0,0,1-.29-.79,4.16,4.16,0,0,1,.38.75c.11.26.28.56.41.94l.41,1.35a26.07,26.07,0,0,1,.3,8.88c-.17,1.87-.43,3.91-.58,6.1a24.61,24.61,0,0,0,.36,7,14.29,14.29,0,0,0,3.52,6.7,27,27,0,0,0,6.49,5.09c4.93,2.83,10.11,4.85,14,8.12a18.94,18.94,0,0,1,4.56,5.42,11.92,11.92,0,0,1,1.54,6,10.47,10.47,0,0,1-1.43,4.89,8.73,8.73,0,0,1-2.59,2.84,7.33,7.33,0,0,1-2.21,1A4.42,4.42,0,0,1,456.54,239.4Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '447.95541858673096px 206.86362075805664px',
          }}
          id="elreqj37vdsvg"
          className="animable"
        />
        <path
          d="M474.54,208.57a4.87,4.87,0,0,0,.94-2.57,6.29,6.29,0,0,0-.72-3.12,7.86,7.86,0,0,0-2.83-3.13A13.86,13.86,0,0,0,467,198.1c-1.86-.33-3.89-.45-6-.78a32.16,32.16,0,0,1-12.93-5.11,31.73,31.73,0,0,1-9.56-10.11,32.11,32.11,0,0,1-3.92-10.68,30.05,30.05,0,0,1-.41-7.67,20.39,20.39,0,0,1,.24-2.07,3,3,0,0,1,.14-.71c.05,0-.12,1-.19,2.8a32.9,32.9,0,0,0,4.53,18.1,31.78,31.78,0,0,0,9.44,9.93,32.35,32.35,0,0,0,12.73,5.07c2.1.34,4.14.48,6,.82a13.83,13.83,0,0,1,5,1.77,7.94,7.94,0,0,1,2.9,3.3,6.35,6.35,0,0,1,.66,3.25,4.51,4.51,0,0,1-.66,2c-.13.19-.26.33-.34.43Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '454.8694496154785px 184.77000427246094px',
          }}
          id="eluxt3ncllgg"
          className="animable"
        />
        <path
          d="M366.81,256.71c1.32-13.81,2.45-28.37,2.45-28.37s-17.49-4.7-18.89-28.27c-1.34-22.47,7.33-73.21,7.33-73.21h0c26.63-7.92,56.27,2,72.5,24.29h0l-12.54,112c-1.45,13-13.79,22.1-27.7,20.43h0C375.92,281.89,365.56,269.87,366.81,256.71Z"
          style={{
            fill: 'rgb(183, 136, 118)',
            transformOrigin: '390.2146110534668px 203.96868133544922px',
          }}
          id="eld7ar3839b09"
          className="animable"
        />
        <path
          d="M360.36,167.42a3,3,0,0,0,2.57,3.28,2.85,2.85,0,0,0,3.33-2.38,3,3,0,0,0-2.57-3.28A2.85,2.85,0,0,0,360.36,167.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '363.3099660873413px 167.86999034881592px',
          }}
          id="el6b77qfojviw"
          className="animable"
        />
        <path
          d="M355.86,163.61c.33.43,2.75-1,5.95-.7s5.39,2.16,5.78,1.8c.19-.16-.12-.89-1.07-1.74a8.21,8.21,0,0,0-4.58-1.92,8,8,0,0,0-4.78,1C356.1,162.75,355.7,163.42,355.86,163.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '361.7346029281616px 162.88143408298492px',
          }}
          id="el0i94gbkol4z"
          className="animable"
        />
        <path
          d="M393.08,171.21a3,3,0,0,0,2.58,3.28,2.85,2.85,0,0,0,3.33-2.38,3,3,0,0,0-2.57-3.28A2.86,2.86,0,0,0,393.08,171.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '396.03503918647766px 171.65996432304382px',
          }}
          id="elixxsy5it6gf"
          className="animable"
        />
        <path
          d="M389.16,168.06c.33.43,2.75-1,5.95-.69s5.39,2.15,5.78,1.79c.18-.15-.12-.89-1.07-1.74a8.24,8.24,0,0,0-4.58-1.92,8,8,0,0,0-4.78,1C389.4,167.2,389,167.87,389.16,168.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '395.032790184021px 167.33163940906525px',
          }}
          id="elejkfwmsfkte"
          className="animable"
        />
        <path
          d="M375.2,190.67c0-.18-1.92-.72-5.11-1.45-.81-.17-1.56-.41-1.65-1a4.23,4.23,0,0,1,.79-2.37l3-6c4.23-8.53,7.38-15.58,7-15.75s-4.05,6.62-8.28,15.15c-1,2.11-2,4.11-2.94,6a4.79,4.79,0,0,0-.74,3.16,2,2,0,0,0,1.23,1.33,5.5,5.5,0,0,0,1.37.33C373.16,190.64,375.17,190.85,375.2,190.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '373.24958753585815px 177.41477870941162px',
          }}
          id="el6ude6je38e3"
          className="animable"
        />
        <path
          d="M369.26,228.34a59.23,59.23,0,0,0,31.89-5.23S392,238.31,369,233.85Z"
          style={{
            fill: 'rgb(170, 101, 80)',
            transformOrigin: '385.07501220703125px 228.8897190093994px',
          }}
          id="elqwyiqevnv"
          className="animable"
        />
        <path
          d="M375.8,198.52a5.8,5.8,0,0,1,5.38-1.64,5.36,5.36,0,0,1,3.45,2.31,3.36,3.36,0,0,1-.13,3.85,3.87,3.87,0,0,1-4.3.64,12.11,12.11,0,0,1-3.85-2.84,3.56,3.56,0,0,1-.82-1,1.07,1.07,0,0,1,.12-1.19"
          style={{
            fill: 'rgb(170, 101, 80)',
            transformOrigin: '380.28814029693604px 200.40758633613586px',
          }}
          id="elbhahcv36duj"
          className="animable"
        />
        <path
          d="M384.41,193.81c-.52-.08-.87,3.39-4.09,5.57s-6.88,1.43-6.95,1.91c-.07.21.76.76,2.32,1a8.66,8.66,0,0,0,5.78-1.4,7.52,7.52,0,0,0,3.2-4.69C385,194.71,384.65,193.81,384.41,193.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '379.08536767959595px 198.07688331604004px',
          }}
          id="elfflntnexy3q"
          className="animable"
        />
        <path
          d="M419.16,175.91a13.87,13.87,0,0,1,7.42,1.21,9.68,9.68,0,0,1,5,5.5,10.12,10.12,0,0,1-.66,7.42,17.23,17.23,0,0,1-4.84,5.83,11.62,11.62,0,0,1-4.8,2.54,5.52,5.52,0,0,1-5.09-1.31"
          style={{
            fill: 'rgb(183, 136, 118)',
            transformOrigin: '424.0936965942383px 187.19791412353516px',
          }}
          id="elf1a33d3xbqk"
          className="animable"
        />
        <path
          d="M419.05,191.09c-.29.06.64,1.67,3,1.28a4.91,4.91,0,0,0,3-2.17,11.15,11.15,0,0,0,1.65-4,6.62,6.62,0,0,0-.62-4.47,4.39,4.39,0,0,0-3.07-2.25c-2.33-.28-3.22,1.27-3,1.34s1.16-.54,2.65,0,2.68,2.57,2.12,5-1.74,4.76-3.16,5.21S419.23,190.9,419.05,191.09Z"
          style={{
            fill: 'rgb(170, 101, 80)',
            transformOrigin: '422.92202162742615px 185.93851709365845px',
          }}
          id="eln1g1kb8cxf"
          className="animable"
        />
        <path
          d="M368.92,136.78a28.42,28.42,0,0,1-19.15,16.13c-.49-5.73-.83-11.53.11-17.21s3.24-11.27,7.38-15.26,10.27-6.14,15.83-4.66"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '361.1876792907715px 134.1105079650879px',
          }}
          id="elrxxn22v1ta"
          className="animable"
        />
        <path
          d="M370.52,126.26a22.82,22.82,0,0,0,23.59,31.12c1.52-.16,3.12-.46,4.54.09s2.53,2,3.44,3.38c3.7,5.53,7.61,11.28,13.44,14.48s14.17,2.88,18.07-2.51c1.89-2.62,2.45-5.95,2.89-9.15,1.48-10.77,2.09-22.34-3.05-31.92-3.81-7.13-10.51-12.42-17.92-15.63s-15.53-4.49-23.6-5c-4.68-.29-9.53-.3-13.88,1.48s-8.1,5.72-8.35,10.41"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '403.221923828125px 144.17986679077148px',
          }}
          id="elxkjw9ozfr9"
          className="animable"
        />
        <path
          d="M435.46,166.71a5.92,5.92,0,0,1-.28-.79c-.16-.52-.43-1.29-.78-2.26a42.27,42.27,0,0,0-3.95-7.87,41.18,41.18,0,0,0-8.67-9.67,56.22,56.22,0,0,0-13.89-7.82c-5.24-2.2-10.37-4-14.86-6.11a51.92,51.92,0,0,1-11.21-6.85,29.19,29.19,0,0,1-5.94-6.55,19,19,0,0,1-1.19-2.1,4,4,0,0,1-.35-.76,7.12,7.12,0,0,1,.44.72,23.23,23.23,0,0,0,1.26,2,30.27,30.27,0,0,0,6,6.39,52.14,52.14,0,0,0,11.17,6.7c4.47,2.07,9.6,3.87,14.86,6.07a56.34,56.34,0,0,1,14,7.92,40.67,40.67,0,0,1,8.68,9.85,40.17,40.17,0,0,1,3.83,8c.33,1,.57,1.77.69,2.31A5,5,0,0,1,435.46,166.71Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '404.8999938964844px 141.32001876831055px',
          }}
          id="elhotofyj4ue6"
          className="animable"
        />
        <path
          d="M428.25,165.44a3.79,3.79,0,0,1-.39-.66c-.26-.43-.64-1.07-1.2-1.84a24.5,24.5,0,0,0-5.75-5.55,56.57,56.57,0,0,0-10.56-5.55c-2.07-.89-4.26-1.81-6.48-2.87s-4.49-2.24-6.73-3.58a58.49,58.49,0,0,1-11.64-9,44.94,44.94,0,0,1-7.28-9.55,37.69,37.69,0,0,1-3.2-7.44c-.26-.92-.45-1.64-.54-2.13a4,4,0,0,1-.14-.76,3.83,3.83,0,0,1,.23.73c.13.49.35,1.19.64,2.1a39.88,39.88,0,0,0,3.32,7.32,45.61,45.61,0,0,0,7.29,9.41A59.72,59.72,0,0,0,397.4,145c2.22,1.33,4.47,2.51,6.68,3.58s4.38,2,6.45,2.88a54.42,54.42,0,0,1,10.58,5.68,23.55,23.55,0,0,1,5.71,5.73,16.16,16.16,0,0,1,1.12,1.9A5,5,0,0,1,428.25,165.44Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '401.29498291015625px 140.9749984741211px',
          }}
          id="el37g4mnc116q"
          className="animable"
        />
        <path
          d="M349.85,162.12a3.51,3.51,0,0,1-.22-.54c-.13-.35-.33-.88-.55-1.57a27.05,27.05,0,0,1-1-6,28.86,28.86,0,0,1,6-18.94,26.05,26.05,0,0,1,4-4.16c1.45-1.18,2.94-2.18,4.36-3.12a45.88,45.88,0,0,0,7.22-5.37,16,16,0,0,0,3.54-4.86c.58-1.31.71-2.11.76-2.1a2.09,2.09,0,0,1-.09.58,11.16,11.16,0,0,1-.49,1.59,15.59,15.59,0,0,1-3.47,5,44.23,44.23,0,0,1-7.21,5.5,53,53,0,0,0-4.31,3.12,26.33,26.33,0,0,0-3.94,4.08,28.49,28.49,0,0,0-4.92,9.75,28.85,28.85,0,0,0-1.11,8.88,30.19,30.19,0,0,0,.84,6q.27,1,.45,1.59A2.37,2.37,0,0,1,349.85,162.12Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '361.0056629180908px 138.78994369506836px',
          }}
          id="elgev6wh0ufmw"
          className="animable"
        />
        <path
          d="M407.16,208.39a22.33,22.33,0,0,1-14.86-5.45l.64-.71a21.06,21.06,0,0,0,33.69-23.37l.89-.35a22.79,22.79,0,0,1-7.94,26.15A21.85,21.85,0,0,1,407.16,208.39Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '410.5946617126465px 193.4506435394287px',
          }}
          id="elc4bro80jev9"
          className="animable"
        />
        <circle
          cx="394.82"
          cy="204.32"
          r="4.61"
          style={{ fill: '#95BD51', transformOrigin: '394.82px 204.32px' }}
          id="elrqs5nnmm6m"
          className="animable"
        />
        <g id="elafqcijuiyi">
          <circle
            cx="430.2"
            cy="180.9"
            r="15.43"
            style={{
              fill: '#95BD51',
              transformOrigin: '430.2px 180.9px',
              transform: 'rotate(-80.83deg)',
            }}
            className="animable"
            id="ely7auakr1k8h"
          />
        </g>
        <path
          d="M427.71,178.75a18.84,18.84,0,0,1,.08-3.91l.18-4.57c0-1.78.08-3.81,0-6.05,0-1.12-.08-2.29-.14-3.5s-.19-2.48-.31-3.79-.35-2.64-.52-4c-.13-.68-.26-1.38-.39-2.08s-.27-1.42-.46-2.13a40.79,40.79,0,0,0-8.08-17,37.6,37.6,0,0,0-15.38-10.78,67.78,67.78,0,0,0-15.14-3.8c-4.44-.62-8.07-.81-10.57-1a19.21,19.21,0,0,1-3.9-.32,19.66,19.66,0,0,1,3.91-.25,94.91,94.91,0,0,1,10.69.51,64.14,64.14,0,0,1,15.51,3.58,38.06,38.06,0,0,1,16,11.1,41.26,41.26,0,0,1,8.27,17.66c.18.73.32,1.46.44,2.19s.24,1.43.36,2.13c.16,1.42.38,2.78.46,4.11s.21,2.62.22,3.85.08,2.42,0,3.55c0,2.27-.13,4.31-.23,6.1s-.28,3.32-.43,4.58A20.07,20.07,0,0,1,427.71,178.75Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '401.0288887023926px 147.1536350250244px',
          }}
          id="eldb3p9lmjxlo"
          className="animable"
        />
        <g id="elljcvl46bl1f">
          <g
            style={{
              opacity: '0.4',
              transformOrigin: '430.6199951171875px 180.9000015258789px',
            }}
            className="animable"
            id="elc6j1y6p50m8"
          >
            <g id="elfa1f58k0m4q">
              <circle
                cx="430.62"
                cy="180.9"
                r="10.62"
                style={{
                  transformOrigin: '430.62px 180.9px',
                  transform: 'rotate(-22.66deg)',
                }}
                className="animable"
                id="elad903c0pnqw"
              />
            </g>
          </g>
        </g>
        <path
          d="M427.13,171a2.33,2.33,0,0,1,.48-.24,7.17,7.17,0,0,1,1.47-.44,8.42,8.42,0,0,1,5.51.94,7.48,7.48,0,0,1,2.83,2.72,8.25,8.25,0,0,1,1.13,4.35,8,8,0,0,1-11.36,7.11,7.82,7.82,0,0,1-3.54-3.49,8.1,8.1,0,0,1-.91-4.41,8.37,8.37,0,0,1,1.31-3.7,7.68,7.68,0,0,1,4.4-3.42,5.05,5.05,0,0,1,1.53-.18,2.26,2.26,0,0,1,.53.08,7.41,7.41,0,0,0-2,.28,7.69,7.69,0,0,0-4.15,3.43,7.51,7.51,0,0,0-.3,7.71,7.43,7.43,0,0,0,3.34,3.26,7.79,7.79,0,0,0,9.21-2.24,7.68,7.68,0,0,0,1.5-4.44,7.83,7.83,0,0,0-1-4.13,7.07,7.07,0,0,0-2.65-2.62,8.35,8.35,0,0,0-5.3-1.06A16.51,16.51,0,0,0,427.13,171Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '430.6336441040039px 178.18997716903687px',
          }}
          id="elqrkj68xz7mb"
          className="animable"
        />
        <path
          d="M430.53,191.36a5.28,5.28,0,0,1-.48-2.51,5.37,5.37,0,0,1,.27-2.53,8.93,8.93,0,0,1,.22,2.51A8.76,8.76,0,0,1,430.53,191.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '430.31474381685257px 188.84000396728516px',
          }}
          id="elbo8pr74ck76"
          className="animable"
        />
        <path
          d="M436.39,189.3a11.81,11.81,0,0,1-1.74-4.48,11.81,11.81,0,0,1,1.74,4.48Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '435.52001953125px 187.0600128173828px',
          }}
          id="el4ipbmybz68f"
          className="animable"
        />
        <path
          d="M440.34,184.68c-.09.1-.82-.41-1.63-1.14s-1.38-1.41-1.29-1.51.82.41,1.63,1.14S440.43,184.58,440.34,184.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '438.8799926042557px 183.35500192642212px',
          }}
          id="elwvf9z8pck4f"
          className="animable"
        />
        <path
          d="M440.62,178.23c-.05.13-.57.06-1.18-.16s-1.06-.5-1-.63.57-.06,1.18.16S440.67,178.1,440.62,178.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '439.5292475223541px 177.83499750494957px',
          }}
          id="elyvy56uf3nz"
          className="animable"
        />
        <path
          d="M423.6,189a8.22,8.22,0,0,1,2.31-4.51,9.94,9.94,0,0,1-1.07,2.3A10.21,10.21,0,0,1,423.6,189Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '424.7550048828125px 186.7449951171875px',
          }}
          id="elzri9px984o"
          className="animable"
        />
        <path
          d="M420.43,183.57c-.1-.1.51-.85,1.35-1.67s1.6-1.42,1.7-1.32-.51.85-1.35,1.67S420.53,183.67,420.43,183.57Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '421.95499789714813px 182.07500386238098px',
          }}
          id="elp830t5agdf"
          className="animable"
        />
        <path
          d="M422.91,176.21c0,.13-.4.36-1,.51s-1.06.17-1.09,0,.39-.37,1-.52S422.87,176.08,422.91,176.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '421.8642649650574px 176.46978250145912px',
          }}
          id="eludpqkcu1jt"
          className="animable"
        />
        <path
          d="M503.62,260.63c-1-5.65-3.21-8.72-4.86-10.33a27.91,27.91,0,0,0-4.89-4.2c-2.24-1.37-5.29-3.06-7.24-3.49-2.41-.52-3-3.65-1-4.55s8.7.39,15.13,5.11,3.17-7.24,2.07-11.62S499,213.47,500,212.09c1.59-2,4.1-.64,5.11,3.76s4.94,17.4,7.23,16.76-3.67-22.86-3.67-22.86-2-4.56.59-5.38c4.74-1.49,9.3,22.57,9.68,24.87.26,1.59,2.78,1,2.41-.71s-6.44-22.05-1.63-23.61c3.69-1.19,3.94,19.76,7.54,23.34s-1.82-15.91,1.76-16.91c1.33-.37,2.38-.46,3.87,11.14.81,6.23.29,14.82,2.72,26.71"
          style={{
            fill: 'rgb(183, 136, 118)',
            transformOrigin: '510.01646614074707px 232.466796875px',
          }}
          id="elm9hqs3lr61"
          className="animable"
        />
        <path
          d="M491.63,305.35l21.86,31.37L503,255.82l31.25-12.33s39.44,151.2-13.45,153.32c0,0-36.61-1-63.93-64.36Z"
          style={{
            fill: 'rgb(183, 136, 118)',
            transformOrigin: '502.62654876708984px 320.1500015258789px',
          }}
          id="el0oe29mt6k07"
          className="animable"
        />
        <path
          d="M526.69,242.9c.06.08-.68.57-1.65,1.65a11.12,11.12,0,0,0-2.56,5l-.12.59-.43-.44a14,14,0,0,0-1.62-1.41,13.86,13.86,0,0,0-6.64-2.58c-1.85-.2-3,0-3-.11a6.67,6.67,0,0,1,3.06-.36,12.75,12.75,0,0,1,8.7,4l-.56.15a10.42,10.42,0,0,1,2.9-5.2A4.92,4.92,0,0,1,526.69,242.9Z"
          style={{
            fill: 'rgb(170, 101, 80)',
            transformOrigin: '518.681694984436px 246.51998901367188px',
          }}
          id="elokzzpeuzoio"
          className="animable"
        />
        <path
          d="M475.93,370.75,449.48,337.2l-6.88,34.32a71.11,71.11,0,0,0,4.12,41.39l3.41,8.17H327.65l3.06-10.91c1.73-13.36-.58-27.3-.18-46.44l-3.4-21.57L308.6,421.08H254.13S284,298.59,302.76,274.35c23.61-30.55,64.87-26.52,64.87-26.52l25.27,39.62,24.69-35.73s42.42-9,75.54,48l17.72,30.37h0l-8.23-62.53L541,258.72s13.85,61.43,12.94,94.33c-.81,29.38-13.32,44.79-30.65,46.31C496,401.74,475.93,370.75,475.93,370.75Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '404.0564880371094px 334.3672180175781px',
          }}
          id="elvrn6gi7lpph"
          className="animable"
        />
        <path
          d="M367.63,247.83l.43-4.94s18.72,4.16,25,36.85c0,0,6.3-30.17,26.46-33.2l3.4,8.69-12.38,32.23-21.74,6.36-21.16-6.36L358,268.35Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '390.4599914550781px 268.35498809814453px',
          }}
          id="elq674mag63d8"
          className="animable"
        />
        <path
          d="M315.45,260.83a5.17,5.17,0,0,1,.1.84c0,.6.1,1.41.18,2.44.13,2.11.35,5.16.65,8.94.61,7.54,1.64,17.95,3.27,29.38s3.57,21.72,5.1,29.13c.77,3.71,1.41,6.7,1.88,8.77.21,1,.38,1.8.51,2.38a4.83,4.83,0,0,1,.14.84,5.65,5.65,0,0,1-.24-.81q-.23-.87-.6-2.37c-.52-2.05-1.22-5-2-8.73-1.62-7.4-3.6-17.69-5.25-29.14s-2.61-21.87-3.12-29.43c-.26-3.78-.43-6.84-.51-8.95,0-1-.06-1.84-.08-2.44S315.44,260.83,315.45,260.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '321.3636956214905px 302.1899871826172px',
          }}
          id="el5jklr9u7vjk"
          className="animable"
        />
        <path
          d="M422.46,250.56a2.59,2.59,0,0,1-.27.47l-.84,1.3-3.12,4.76c-2.62,4-6.15,9.65-9.83,16-.14.25-.29.49-.42.73l-.24.41-.2-.43a14.76,14.76,0,0,0-2.69-4.33,4.89,4.89,0,0,0-4.17-1.56,5.73,5.73,0,0,0-3.44,2.26,10.63,10.63,0,0,0-1.72,3.29c-.7,2.2-1.11,4.05-1.64,5.25a10.92,10.92,0,0,1-.65,1.35q-.27.44-.3.42s.34-.63.78-1.84.81-3,1.49-5.28a10.57,10.57,0,0,1,1.72-3.44,6,6,0,0,1,3.69-2.45,5.29,5.29,0,0,1,4.57,1.66,14.8,14.8,0,0,1,2.81,4.46l-.44,0,.42-.73c3.68-6.36,7.27-12,10-15.94,1.35-2,2.47-3.59,3.25-4.68.38-.5.68-.92.92-1.25A2.56,2.56,0,0,1,422.46,250.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '407.6949920654297px 265.52046966552734px',
          }}
          id="elltexu641asl"
          className="animable"
        />
        <path
          d="M404.63,269.07s-.05.15-.2.42l-.66,1.16-2.51,4.22-3.78,6.21-2.25,3.67c-.4.63-.8,1.28-1.21,1.94a1.78,1.78,0,0,1-.47.48.89.89,0,0,1-.76.1,1.9,1.9,0,0,1-1-.91c-3.51-5.28-6.13-10.39-8.18-14-1-1.81-1.85-3.26-2.43-4.26a13.45,13.45,0,0,1-.88-1.57s.12.12.29.37.44.61.75,1.1c.64,1,1.52,2.4,2.57,4.19,2.13,3.55,4.8,8.63,8.3,13.88.21.34.41.63.68.71s.48-.1.69-.39l1.2-1.92,2.27-3.65,3.87-6.16,2.64-4.13c.3-.44.54-.81.75-1.11A1.87,1.87,0,0,1,404.63,269.07Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '392.46498107910156px 276.9218444824219px',
          }}
          id="elb4k57kc3e9"
          className="animable"
        />
        <path
          d="M472.45,272a5.23,5.23,0,0,1-.29.65q-.33.69-.9,1.83c-.8,1.58-1.92,3.88-3.26,6.74s-2.86,6.31-4.46,10.17-3.23,8.16-4.81,12.72-2.9,9-4,13-2,7.68-2.73,10.76-1.24,5.59-1.58,7.32c-.17.83-.31,1.49-.41,2a3.62,3.62,0,0,1-.18.69,3.37,3.37,0,0,1,.08-.71c.08-.51.19-1.18.32-2,.28-1.75.77-4.27,1.43-7.37s1.54-6.76,2.63-10.81,2.45-8.44,4-13,3.25-8.86,4.85-12.73,3.19-7.3,4.58-10.15,2.55-5.13,3.4-6.68l1-1.78A3.37,3.37,0,0,1,472.45,272Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '461.1400146484375px 304.9399871826172px',
          }}
          id="elbk1be7cv81o"
          className="animable"
        />
        <path
          d="M416.42,396.24a7.2,7.2,0,0,1-.76,0l-2.19-.17c-1-.08-2.11-.18-3.45-.35s-2.88-.32-4.56-.58c-3.38-.46-7.38-1.16-11.79-2.07s-9.22-2.13-14.21-3.6-9.66-3.14-13.87-4.75-7.92-3.25-11-4.71c-1.56-.7-2.93-1.41-4.14-2s-2.25-1.14-3.08-1.6l-1.93-1.05a5,5,0,0,1-.65-.39,3.88,3.88,0,0,1,.7.3l2,1c.85.43,1.89,1,3.11,1.52s2.6,1.26,4.16,1.93c3.1,1.42,6.83,3,11,4.6s8.87,3.21,13.84,4.7,9.78,2.66,14.16,3.63,8.38,1.67,11.75,2.17c1.67.29,3.2.47,4.54.65s2.49.33,3.44.43l2.18.27A4.31,4.31,0,0,1,416.42,396.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '380.6050109863281px 385.60999298095703px',
          }}
          id="ellbij8t28ik"
          className="animable"
        />
        <path
          d="M411,398.38a2.18,2.18,0,0,1-.51.13l-1.46.28c-1.27.23-3.12.52-5.41.84a181.84,181.84,0,0,1-36,1.25c-2.31-.16-4.17-.32-5.45-.47l-1.48-.17a3.43,3.43,0,0,1-.51-.09,1.89,1.89,0,0,1,.52,0l1.48.08c1.29.09,3.15.2,5.46.31,4.6.22,11,.37,18,.13s13.38-.84,18-1.38c2.29-.27,4.14-.51,5.42-.68l1.48-.19A1.72,1.72,0,0,1,411,398.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '385.58998107910156px 399.8180876970291px',
          }}
          id="elhtg8ulcllbe"
          className="animable"
        />
        <path
          d="M454.35,343.38a3.57,3.57,0,0,1,.14-.72l.51-2,1.9-7.49c1.61-6.32,3.74-15.07,6.37-24.67,1.32-4.8,2.67-9.35,4-13.46s2.61-7.77,3.79-10.81c.56-1.54,1.14-2.9,1.62-4.1s.93-2.22,1.31-3.05l.87-1.91a4.33,4.33,0,0,1,.34-.66,4.58,4.58,0,0,1-.25.7c-.19.48-.45,1.13-.78,1.94s-.77,1.88-1.23,3.09-1,2.57-1.55,4.11c-1.14,3.05-2.38,6.73-3.68,10.83s-2.63,8.66-3.95,13.45c-2.62,9.59-4.8,18.33-6.5,24.63-.84,3.15-1.54,5.7-2.05,7.45l-.6,2A3.28,3.28,0,0,1,454.35,343.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '464.77500915527344px 308.94500732421875px',
          }}
          id="el9qjtvk3wa94"
          className="animable"
        />
        <path
          d="M326.49,341.74a6,6,0,0,1-.52-.6c-.32-.42-.83-1-1.39-1.81a52.13,52.13,0,0,1-4.37-7.18,69.53,69.53,0,0,1-4.59-11.6,102.44,102.44,0,0,1-3.18-14.93c-1.46-10.74-1.7-20.56-2.14-27.62-.2-3.54-.39-6.4-.53-8.38-.07-.95-.13-1.71-.17-2.27a5.35,5.35,0,0,1,0-.8,4.65,4.65,0,0,1,.13.79c.06.51.16,1.28.26,2.27.21,2,.45,4.83.69,8.36.53,7.07.82,16.88,2.28,27.58a104.44,104.44,0,0,0,3.13,14.87A71.24,71.24,0,0,0,320.52,332a58.81,58.81,0,0,0,4.21,7.23c.54.83,1,1.42,1.32,1.86A4.11,4.11,0,0,1,326.49,341.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '318.03748893737793px 304.14500427246094px',
          }}
          id="ellk7hpaw783n"
          className="animable"
        />
        <path
          d="M321.84,319.72c0,.15-1.42.46-3,1.38s-2.53,2-2.64,1.9a7,7,0,0,1,5.6-3.28Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '319.0199890136719px 321.3632318973541px',
          }}
          id="els62x5974fji"
          className="animable"
        />
        <path
          d="M320.91,306.88a26.34,26.34,0,0,0-3.74,1.34,27,27,0,0,0-3.22,2.32,7.88,7.88,0,0,1,7-3.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '317.4499969482422px 308.70630049705505px',
          }}
          id="elmxo9x834kgb"
          className="animable"
        />
        <path
          d="M318.1,295.14a26.35,26.35,0,0,0-3,1,26.86,26.86,0,0,0-2.59,1.75,5.65,5.65,0,0,1,5.55-2.75Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '315.3050079345703px 296.4945989847183px',
          }}
          id="elu9tt0tfy6dp"
          className="animable"
        />
        <path
          d="M316.73,283c0,.14-1.25.39-2.69,1s-2.5,1.36-2.59,1.25a5,5,0,0,1,2.39-1.71A5.07,5.07,0,0,1,316.73,283Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '314.0900115966797px 284.1152443885803px',
          }}
          id="el31d1n3102is"
          className="animable"
        />
        <path
          d="M315.94,273.22c0,.14-1.26.38-2.7,1.06s-2.44,1.51-2.53,1.4a4.75,4.75,0,0,1,2.32-1.85A4.81,4.81,0,0,1,315.94,273.22Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '313.3249969482422px 274.441042304039px',
          }}
          id="eljfzimi0zabd"
          className="animable"
        />
        <path
          d="M456.92,328.4c-.12.09-.77-.79-2-1.26a13.94,13.94,0,0,0-2.29-.47,2.68,2.68,0,0,1,2.47,0C456.5,327.23,457.05,328.36,456.92,328.4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '454.78426814079285px 327.3874238729477px',
          }}
          id="elt1ftve7axq"
          className="animable"
        />
        <path
          d="M460.64,318.39a6.43,6.43,0,0,0-5.3-3.43c0-.06.37-.19,1-.17a4.85,4.85,0,0,1,2.36.77,4.77,4.77,0,0,1,1.67,1.84C460.66,318,460.7,318.37,460.64,318.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '458.00198888778687px 316.58897054195404px',
          }}
          id="ely8hlj6nqur"
          className="animable"
        />
        <path
          d="M463.43,307.38a6.74,6.74,0,0,0-5.58-2.21c0-.05.32-.23.92-.31a4.69,4.69,0,0,1,2.32.3,4.74,4.74,0,0,1,1.89,1.37C463.36,307,463.48,307.36,463.43,307.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '460.645366191864px 306.1021535396576px',
          }}
          id="el0nheleweaoxl"
          className="animable"
        />
        <path
          d="M466.72,296.81c-.13.07-.65-.92-1.81-1.51a10.69,10.69,0,0,0-2.26-.64c0-.06.26-.18.73-.21a3.63,3.63,0,0,1,3.1,1.64C466.72,296.49,466.77,296.78,466.72,296.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '464.6937642097473px 295.63148188591003px',
          }}
          id="el85ctvvu7lsq"
          className="animable"
        />
        <path
          d="M470.56,287.1a6.81,6.81,0,0,0-2-1.72,7.12,7.12,0,0,0-2.63-.44c0-.05.26-.24.79-.33a3.78,3.78,0,0,1,3.61,1.67C470.57,286.74,470.61,287.08,470.56,287.1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '468.2544574737549px 285.8412221670151px',
          }}
          id="elfenhcjvubln"
          className="animable"
        />
        <path
          d="M407.7,273.22a2.06,2.06,0,0,1-.22.46l-.7,1.28c-.62,1.1-1.54,2.69-2.7,4.64s-2.56,4.25-4.16,6.78c-.81,1.26-1.66,2.58-2.58,3.93a43.57,43.57,0,0,1-3,4.07,4.42,4.42,0,0,1-1,.92.69.69,0,0,1-.44.09,1.41,1.41,0,0,1-.38-.12,4.07,4.07,0,0,1-.57-.39,14.31,14.31,0,0,1-1.75-1.83c-1-1.26-2-2.54-2.83-3.76-1.72-2.46-3.18-4.73-4.39-6.65s-2.15-3.48-2.79-4.58l-.72-1.27a1.61,1.61,0,0,1-.22-.46,3,3,0,0,1,.3.41l.8,1.22c.73,1.12,1.72,2.64,2.92,4.5s2.74,4.13,4.47,6.56c.87,1.22,1.8,2.48,2.83,3.72a14.82,14.82,0,0,0,1.69,1.76c.3.24.68.5.87.35a4.25,4.25,0,0,0,.87-.8,45.8,45.8,0,0,0,3-4c.92-1.34,1.78-2.65,2.59-3.91,1.62-2.51,3.05-4.79,4.25-6.72s2.13-3.41,2.83-4.55l.79-1.23C407.58,273.35,407.68,273.21,407.7,273.22Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '393.47499084472656px 284.30767250061035px',
          }}
          id="eluprnx5qqvn"
          className="animable"
        />
        <path
          d="M386.39,287.45c-.06,0-.17-.34-.13-.92a3.94,3.94,0,0,1,.84-2.06,3.89,3.89,0,0,1,1.81-1.3c.55-.17.91-.14.92-.08a7.22,7.22,0,0,0-2.34,1.69A7,7,0,0,0,386.39,287.45Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '388.0407454967499px 285.2463467121124px',
          }}
          id="elho3mskrkqmd"
          className="animable"
        />
        <path
          d="M393,295.33a17.47,17.47,0,0,1-.06-7.88,25.61,25.61,0,0,1,.07,3.94A26.08,26.08,0,0,1,393,295.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '392.7994909286499px 291.38999938964844px',
          }}
          id="elg85bunhg3dh"
          className="animable"
        />
        <path
          d="M400.42,285.29c-.14,0-.45-1.07-1.49-1.92a9.75,9.75,0,0,0-2.15-1.12c0-.06.3-.13.78-.05a3.65,3.65,0,0,1,1.69.79,3.59,3.59,0,0,1,1.08,1.52C400.49,285,400.48,285.27,400.42,285.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '398.6201800107956px 283.72701716423035px',
          }}
          id="els8dgu3lmxcq"
          className="animable"
        />
        <path
          d="M405.29,277.14a9.72,9.72,0,0,0-1.23-2.07,10.21,10.21,0,0,0-2-1.37c0-.06.31-.09.77,0a3.65,3.65,0,0,1,1.57,1,3.56,3.56,0,0,1,.88,1.63C405.4,276.83,405.35,277.13,405.29,277.14Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '403.7066501379013px 275.3916199207306px',
          }}
          id="elg06h75ho4rp"
          className="animable"
        />
        <path
          d="M381.42,280c-.06,0-.22-.37-.24-1a5.13,5.13,0,0,1,.61-2.52,5.27,5.27,0,0,1,1.75-1.92c.57-.35,1-.43,1-.38a6.88,6.88,0,0,0-3.13,5.86Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '382.85960721969604px 277.10321140289307px',
          }}
          id="eliq1nsw8u1di"
          className="animable"
        />
        <g id="elxsu96cd8ov">
          <g
            style={{
              opacity: '0.4',
              transformOrigin: '380.1680097579956px 264.6892395019531px',
            }}
            className="animable"
            id="el887ioxd03jv"
          >
            <path
              d="M367.37,247.75c2.14,8.22,5.72,21.61,9.59,32.08a3.41,3.41,0,0,0,.74,1.33c1,.93,2.67.36,3.6-.63a24.24,24.24,0,0,0,2.11-3.23,4.17,4.17,0,0,1,3.07-2.09,3.58,3.58,0,0,1,2.72,1.36,15.56,15.56,0,0,1,1.67,2.67,2,2,0,0,0,1.18,1.13.71.71,0,0,0,.84-1l-3.42-8.88s-1.57-6.51-7-5.5c-6.08,1.13-3.32,11.13-3.32,11.13S367.28,247.4,367.37,247.75Z"
              id="eltfyg4ycpr3j"
              style={{
                transformOrigin: '380.1680097579956px 264.6892395019531px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M393.06,279.74a2.39,2.39,0,0,1-.29-.58c-.18-.39-.43-1-.74-1.71-.61-1.56-1.47-3.72-2.52-6.37-.27-.67-.56-1.37-.87-2.09a6.55,6.55,0,0,0-1.25-2,6,6,0,0,0-4.74-1.77,4.68,4.68,0,0,0-2.5,1.12,6.23,6.23,0,0,0-1.35,2.59,7.33,7.33,0,0,0-.21,3,25.6,25.6,0,0,0,.57,3.18c.09.39.19.78.28,1.14l-.48.14c-1.4-4-3-7.76-4.48-11.13s-2.83-6.41-3.89-9-1.84-4.68-2.31-6.16c-.25-.73-.4-1.31-.51-1.71a2.52,2.52,0,0,1-.14-.6,3.73,3.73,0,0,1,.23.57c.14.39.32,1,.6,1.68.52,1.45,1.35,3.54,2.45,6.08s2.47,5.56,4,8.93,3.13,7.11,4.54,11.16l-.47.15c-.09-.37-.19-.76-.29-1.15a26,26,0,0,1-.57-3.25,7.71,7.71,0,0,1,.24-3.24,6.7,6.7,0,0,1,1.48-2.78,5.08,5.08,0,0,1,2.78-1.23,6.35,6.35,0,0,1,5.09,1.94,7.11,7.11,0,0,1,1.3,2.15c.31.73.58,1.44.85,2.11,1,2.67,1.79,4.85,2.37,6.43.27.72.48,1.3.65,1.74A3.63,3.63,0,0,1,393.06,279.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '380.3450012207031px 263.76500701904297px',
          }}
          id="elftobpl0wl0a"
          className="animable"
        />
        <g id="elcmp8jr2y0nf">
          <g
            style={{
              opacity: '0.4',
              transformOrigin: '407.82348823547363px 266.11499786376953px',
            }}
            className="animable"
            id="elg3ep892jbgk"
          >
            <path
              d="M393.54,279.5c-.2.14-.05.51.19.56a.87.87,0,0,0,.69-.24A15.09,15.09,0,0,0,397.3,276c.9-1.34,2.21-2.62,3.82-2.62s3.09,1.42,3.93,2.91,1.42,3.17,2.64,4.37a119.9,119.9,0,0,0,14.51-29.09c-2,1.39-3.33,3.56-4.58,5.65q-4.87,8.13-9.74,16.25a12.5,12.5,0,0,0-2.75-4.33,5.34,5.34,0,0,0-4.72-1.52c-1.89.45-3.21,2.16-4.13,3.88a23.07,23.07,0,0,0-2.61,8.09"
              id="elyrqtdubs34"
              style={{
                transformOrigin: '407.82348823547363px 266.11499786376953px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M521.25,359.61a5.91,5.91,0,0,1-.65-1.09c-.39-.72-.93-1.78-1.56-3.09a114.13,114.13,0,0,1-4.39-10.55,112.56,112.56,0,0,1-3.3-10.93c-.35-1.42-.6-2.57-.76-3.38a7.07,7.07,0,0,1-.19-1.25,6.07,6.07,0,0,1,.38,1.21c.24.88.55,2,.91,3.33.78,2.81,1.93,6.67,3.43,10.86s3.06,7.9,4.24,10.56c.57,1.26,1,2.32,1.41,3.15A6.17,6.17,0,0,1,521.25,359.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '515.8249969482422px 344.4650115966797px',
          }}
          id="el8r4mso729xe"
          className="animable"
        />
        <path
          d="M511.74,357.73a5.75,5.75,0,0,1-.4-1.09c-.23-.72-.52-1.76-.84-3.06a66.6,66.6,0,0,1-1.64-20.8c.11-1.33.23-2.41.35-3.15a4.36,4.36,0,0,1,.23-1.14,5.37,5.37,0,0,1,0,1.16c-.06.74-.12,1.82-.19,3.15a81.05,81.05,0,0,0,1.63,20.7c.28,1.31.51,2.36.69,3.09A4.47,4.47,0,0,1,511.74,357.73Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '510.197203040123px 343.1100158691406px',
          }}
          id="elivhhi1cjlhf"
          className="animable"
        />
        <path
          d="M542.3,270.19a3.57,3.57,0,0,1,.76.29l.15.07-.15.06A135.36,135.36,0,0,1,524,275.49c-5.58,1-10.69,1.62-14.39,1.92-1.85.15-3.35.24-4.39.27a9.15,9.15,0,0,1-1.62,0,11.47,11.47,0,0,1,1.6-.2l4.38-.43c3.68-.39,8.77-1,14.33-2.06,9.28-1.69,16.91-3.94,19.14-4.52v.12A3.51,3.51,0,0,1,542.3,270.19Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '523.4049987792969px 273.9529438018799px',
          }}
          id="elgyhe4yuptjb"
          className="animable"
        />
        <path
          d="M533.69,265.85s.09-.16.4-.25a1.6,1.6,0,0,1,1.29.29,1.83,1.83,0,0,1,.82,1.78,1.45,1.45,0,0,1-.73,1,2,2,0,0,1-1.28.24,2.16,2.16,0,0,1-1.18-.55,1.58,1.58,0,0,1-.47-1.15,2,2,0,0,1,1.07-1.64,1.84,1.84,0,0,1,1.29-.21c.31.08.43.22.42.24a2.08,2.08,0,0,0-1.53.27,1.67,1.67,0,0,0-.79,1.34,1.29,1.29,0,0,0,1.25,1.2,1.26,1.26,0,0,0,1.5-.84,1.65,1.65,0,0,0-1.62-1.78C533.85,265.81,533.71,265.9,533.69,265.85Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '534.3781007528305px 267.1270364522934px',
          }}
          id="eld9dmwmedjg5"
          className="animable"
        />
        <path
          d="M385.09,287a5.62,5.62,0,0,1-.55.48c-.38.28-.9.76-1.65,1.26a37.51,37.51,0,0,1-6.65,3.79,40.63,40.63,0,0,1-10.92,3.1,41.77,41.77,0,0,1-6.71.36,40.85,40.85,0,0,1-7.16-.89c-4.84-1.09-9.2-2.87-13.31-4a35.36,35.36,0,0,0-5.89-1.16A23.86,23.86,0,0,0,327,290a16,16,0,0,0-7.07,2.49,27.55,27.55,0,0,0-2.17,1.75,9.77,9.77,0,0,1,2.06-1.91,15.75,15.75,0,0,1,7.14-2.68,24.31,24.31,0,0,1,5.3-.11,34.78,34.78,0,0,1,6,1.13c4.15,1.08,8.51,2.85,13.29,3.93a41.8,41.8,0,0,0,7.08.89,43.31,43.31,0,0,0,6.63-.33,40.87,40.87,0,0,0,10.84-3,39.36,39.36,0,0,0,6.68-3.62c.77-.47,1.3-.92,1.7-1.18A3.16,3.16,0,0,1,385.09,287Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '351.42498779296875px 291.5025734901428px',
          }}
          id="el02hpcve8xx8b"
          className="animable"
        />
        <path
          d="M448.63,328.14a1.43,1.43,0,0,1-.3-.14l-.87-.45c-.38-.19-.87-.39-1.44-.65s-1.25-.49-2-.69a31.59,31.59,0,0,0-13.62-.49,78.14,78.14,0,0,0-9.27,2.1c-3.3.9-6.82,1.95-10.6,2.72a39.22,39.22,0,0,1-12.09.74,57.71,57.71,0,0,1-12.65-3c-4.23-1.42-8.27-3-12.24-4.33a62,62,0,0,0-11.67-2.87,54.9,54.9,0,0,0-20.24,1.1,60.27,60.27,0,0,0-7.46,2.41c-1.05.46-2.05.87-2.94,1.3s-1.7.82-2.41,1.22l-1.89,1.05-1.35.84-.83.5a1,1,0,0,1-.3.16l.27-.2.81-.55c.35-.23.79-.54,1.32-.87l1.87-1.1c.71-.41,1.53-.8,2.41-1.26s1.88-.87,2.94-1.35a59.28,59.28,0,0,1,7.47-2.49,54.63,54.63,0,0,1,20.39-1.21,62,62,0,0,1,11.77,2.86c4,1.32,8,2.9,12.23,4.32a57.92,57.92,0,0,0,12.55,3,38.41,38.41,0,0,0,11.95-.7c3.76-.75,7.27-1.78,10.58-2.67a77.82,77.82,0,0,1,9.33-2.05A31.1,31.1,0,0,1,444,326c.79.22,1.46.52,2.05.74s1.05.48,1.43.69l.84.5C448.54,328.07,448.64,328.13,448.63,328.14Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '386.5453681945801px 325.8152346611023px',
          }}
          id="el3p8e4pfifcp"
          className="animable"
        />
        <path
          d="M398.24,286.25a22.35,22.35,0,0,0,2.56.56,18.59,18.59,0,0,0,7.05-.56,86.59,86.59,0,0,0,9.93-3.72,32.67,32.67,0,0,1,6.06-1.8,28.57,28.57,0,0,1,6.77-.39,39.2,39.2,0,0,1,12.69,3,67.31,67.31,0,0,1,9.46,4.91c2.59,1.58,4.62,3,6,3.91.67.46,1.2.83,1.6,1.12a3.75,3.75,0,0,1,.54.41,3.08,3.08,0,0,1-.59-.33l-1.65-1c-1.44-.9-3.49-2.23-6.1-3.77a73,73,0,0,0-9.45-4.79,39.7,39.7,0,0,0-12.55-3,29.31,29.31,0,0,0-6.66.37,33.17,33.17,0,0,0-6,1.76c-3.72,1.44-7,3-10,3.63a17.79,17.79,0,0,1-7.16.41A8.85,8.85,0,0,1,398.24,286.25Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '429.57000732421875px 286.9880328178406px',
          }}
          id="elk5d0bas22is"
          className="animable"
        />
        <path
          d="M456.69,261.17a9.57,9.57,0,0,1-1.42.43c-.47.13-1,.27-1.7.4s-1.42.31-2.27.43a51.66,51.66,0,0,1-6,.65A59.41,59.41,0,0,1,438,263a58.71,58.71,0,0,1-7.28-1.12,52.71,52.71,0,0,1-5.79-1.64c-.81-.26-1.52-.57-2.16-.81s-1.17-.48-1.6-.68a8.71,8.71,0,0,1-1.33-.67,8.77,8.77,0,0,1,1.4.49c.45.18,1,.39,1.63.6s1.36.5,2.17.74c1.62.52,3.58,1.05,5.77,1.53a58.47,58.47,0,0,0,14.53,1.23c2.24-.1,4.26-.29,5.94-.53.85-.1,1.6-.25,2.27-.36s1.24-.22,1.7-.32A7.39,7.39,0,0,1,456.69,261.17Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '438.2650146484375px 260.6179106235504px',
          }}
          id="eld07fhe88gi"
          className="animable"
        />
        <path
          d="M315.86,267.59a3.17,3.17,0,0,1,.43-.38c.3-.24.74-.6,1.32-1,1.15-.88,2.83-2.12,5-3.56a69.72,69.72,0,0,1,18.11-8.94,42.6,42.6,0,0,1,20.06-1.4,31.57,31.57,0,0,1,5.9,1.69c.68.25,1.18.52,1.53.67a2.7,2.7,0,0,1,.51.27s-.75-.27-2.1-.76a33.58,33.58,0,0,0-5.9-1.52,43.74,43.74,0,0,0-19.86,1.52,73.7,73.7,0,0,0-18,8.76c-2.17,1.4-3.89,2.6-5.07,3.43l-1.37,1A2.13,2.13,0,0,1,315.86,267.59Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '342.2899627685547px 259.6480121612549px',
          }}
          id="el7ibybiqw5xi"
          className="animable"
        />
        <path
          d="M441.72,372.46a.92.92,0,0,1-.28.08l-.84.18a9.68,9.68,0,0,1-1.38.21l-.88.1-1,0c-2.87.12-7-.62-11.87-2.18-2.44-.76-5.08-1.7-7.95-2.55a48.88,48.88,0,0,0-9.35-1.81c-6.71-.64-14.13.17-21.77,1.56s-14.9,3.12-21.62,3.92a67.46,67.46,0,0,1-17.94.11,37.2,37.2,0,0,1-11.56-3.49l-1.68-.88L332.4,367l-.72-.47-.23-.17a.93.93,0,0,1,.26.13l.74.42,1.2.71,1.69.84a38.58,38.58,0,0,0,11.53,3.32,68.79,68.79,0,0,0,17.83-.22c6.69-.83,13.91-2.57,21.59-4s15.13-2.2,21.9-1.52a48.5,48.5,0,0,1,9.42,1.87c2.88.87,5.52,1.82,7.94,2.6a37.8,37.8,0,0,0,11.77,2.33h1l.88-.08a9.07,9.07,0,0,0,1.38-.16l.84-.13Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '386.5849914550781px 369.41603088378906px',
          }}
          id="eldsvx209q3ki"
          className="animable"
        />
        <g id="el86qzztdgjk">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '384.2899932861328px 390.0989980697632px',
            }}
            className="animable"
            id="elqnbns2x600b"
          >
            <path
              d="M353.62,379.35c4.53,11.31,13.3,19.34,25.37,21s24.28-1.1,36-4.3c-21.37-3-40.28-5.95-61.4-16.7"
              id="el0scrz8uwui8"
              style={{
                transformOrigin: '384.2899932861328px 390.0989980697632px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M444.78,410.45l-.29-.11-.85-.36-3.23-1.44c-2.82-1.23-6.85-3.13-11.88-5.31a52.46,52.46,0,0,0-8.47-2.87,27.17,27.17,0,0,0-10.16-.47,35.82,35.82,0,0,0-5.4,1.23,56.74,56.74,0,0,0-5.41,2c-3.61,1.58-7.2,3.54-10.9,5.52a86.74,86.74,0,0,1-11.12,5.18,34.39,34.39,0,0,1-11.19,2.27,25.15,25.15,0,0,1-10.13-2,68.87,68.87,0,0,1-8-4.08c-2.39-1.37-4.54-2.61-6.49-3.56a34.7,34.7,0,0,0-5.17-2.1,17.86,17.86,0,0,0-2-.53,11,11,0,0,0-1.46-.28l-.91-.15a1.24,1.24,0,0,1-.31-.06,1,1,0,0,1,.31,0l.92.1a10.41,10.41,0,0,1,1.48.24,17.09,17.09,0,0,1,2,.48,34.49,34.49,0,0,1,5.23,2c2,.93,4.15,2.16,6.54,3.5a68.67,68.67,0,0,0,8,4,25,25,0,0,0,10,1.91,34.18,34.18,0,0,0,11-2.28,86.93,86.93,0,0,0,11-5.16c3.69-2,7.29-3.94,10.93-5.52a55.35,55.35,0,0,1,5.47-2.06,37.74,37.74,0,0,1,5.48-1.22,27.49,27.49,0,0,1,10.31.52,51.08,51.08,0,0,1,8.52,3c5,2.23,9,4.17,11.82,5.46l3.19,1.52.83.41C444.69,410.39,444.79,410.44,444.78,410.45Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '388.0953254699707px 407.57432556152344px',
          }}
          id="el1apz9ukoxi8j"
          className="animable"
        />
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ContactUs;

ContactUs.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
